import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Logger, LogService } from './nio-common/util';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { NavigationService } from './shared/services/navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private readonly _logger: Logger;

  constructor(
    private readonly http: HttpClient,
    private readonly logService: LogService,
    private readonly navigationService: NavigationService,
    private readonly router: Router,
    private readonly googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this._logger = this.logService.createLogger(AppComponent.name);

    // Initialize GA immediately in constructor (before any router events)
    this.googleAnalyticsService.initialize();
  }

  ngOnInit(): void {
    this.navigationService.initLocationHistory();

    // Set up router tracking - GA is already available
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => {
        const pageTitle = document.title || 'Photo Gallery App';
        const pagePath = event.urlAfterRedirects;

        if (!environment.production) {
          console.log('GA Page View:', { pageTitle, pagePath });
        }

        this.googleAnalyticsService.trackPageView(pageTitle, pagePath);

        if (!environment.production) {
          console.log('GA Status after tracking:', this.googleAnalyticsService.getStatus());
        }
      });
  }
}
